<template>
  <div>
    <el-card class="">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('goldDetail.queryCondition') }}</div>
      </div>
      <div class="">
        <el-form :inline="true" :model="goldDetailInfo.conditions" class="flex justify-start">
          <el-form-item>
            <el-input
              :placeholder="$t('goldDetail.goldIdPlaceholder')"
              v-model="goldDetailInfo.conditions.goldId"
              clearable
            />
          </el-form-item>
          <el-form-item>
            <el-input
              :placeholder="$t('goldDetail.goldNamePlaceholder')"
              v-model="goldDetailInfo.conditions.goldName"
              clearable
            />
          </el-form-item>
          <el-form-item>
            <el-input
              :placeholder="$t('goldDetail.objIdPlaceholder')"
              v-model="goldDetailInfo.conditions.objId"
              clearable
            />
          </el-form-item>
          <el-form-item>
            <el-input
              :placeholder="$t('goldDetail.orderIdPlaceholder')"
              v-model="goldDetailInfo.conditions.orderId"
              clearable
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="_queryGoldDetailMethod()">
              <i class="el-icon-search"></i>
              {{ $t('goldDetail.query') }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-card class="margin-top-sm">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('goldDetail.goldTransaction') }}</div>
      </div>
      <div class="">
        <gold-detail-table
          :data="goldDetailInfo.goldDetails"
          :loading="loading"
          @refresh="_listGoldDetails"
        />
        <el-pagination
          @current-change="handlePageChange"
          :current-page="goldDetailInfo.conditions.page"
          :page-size="goldDetailInfo.conditions.row"
          :total="goldDetailInfo.total"
          layout="total, prev, pager, next"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
import { listGoldDetail } from '@/api/admin/goldDetail/goldDetailApi'
import GoldDetailTable from '@/components/admin/goldDetail/goldDetailTable.vue'

export default {
  name: 'GoldDetail',
  components: {
    GoldDetailTable
  },
  data() {
    return {
      loading: false,
      goldDetailInfo: {
        goldDetails: [],
        total: 0,
        records: 1,
        conditions: {
          goldId: '',
          goldName: '',
          objId: '',
          orderId: '',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this._listGoldDetails()
  },
  methods: {
    async _listGoldDetails(page = 1, rows = 10) {
      this.loading = true
      this.goldDetailInfo.conditions.page = page
      this.goldDetailInfo.conditions.row = rows
      
      try {
        const res = await listGoldDetail(this.goldDetailInfo.conditions)
        this.goldDetailInfo.goldDetails = res.data
        this.goldDetailInfo.total = res.total
        this.goldDetailInfo.records = res.records
        console.log(this.goldDetailInfo.records)
      } catch (error) {
        console.error('获取金币交易记录失败:', error)
      } finally {
        this.loading = false
      }
    },
    _queryGoldDetailMethod() {
      this._listGoldDetails()
    },
    handlePageChange(currentPage) {
      this._listGoldDetails(currentPage)
    }
  }
}
</script>

<style scoped>
.ibox {
  margin-bottom: 20px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 1px rgba(0,0,0,0.1);
}
.ibox-title {
  border-bottom: 1px solid #e7eaec;
  padding: 15px 15px 7px;
  min-height: 48px;
}
.ibox-content {
  padding: 15px;
}
.el-col {
  margin-bottom: 15px;
}
</style>